import { PaymentDTO, Permission, Res, SaleDTO, TicketDTO } from 'core/api';
import { CustomError, Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { addPrecondition, Command } from 'pos/common';
import { processPayment } from '../helpers/payments-processing';
import { Message } from 'core/ui-next/modal';

type SplitTicketPaymentParams = {
	ticket: TicketDTO,
	parts: number,
	addPayments: (payments: PaymentDTO[], prepayAmount: number) => Promise<Result<SaleDTO, CustomError>>
}

export async function splitTicketPayments({ ticket, parts, addPayments }: SplitTicketPaymentParams): Promise<Result> {

	if (ticket.PendingAmount === 0) {
		await Message.show(Res.Msg.MSG_PARTIAL_TICKET_PAYMENTS_NOT_PENDING_AMOUNT());
		return Result.error();
	}

	const paymentAmount = +(ticket.PendingAmount / parts).toFixed(2); // El + es para convertirlo de nuevo a number
	const remainingAmount = ticket.PendingAmount - paymentAmount * (parts - 1);

	let currentPayment = 0;
	while (currentPayment < parts) {
		const amount = currentPayment === parts - 1 ? remainingAmount : paymentAmount;
		const result = await processPayment({ mode: 'ADD', pendingAmount: amount, ticketGlobalId: ticket.GlobalId, process: (payments, prepayAmount) => addPayments(payments, prepayAmount), pendingPaymentParts: { currentPart: ++currentPayment, totalParts: parts } });
		if (!result.ok) {
			await Message.show(Res.Msg.MSG_PARTIAL_TICKET_PAYMENTS_NOT_COMPLETED());
			return Result.error();
		}
	}

	// ÑAPA: Espero un segundo antes de hacer el cierre final del ticket para que en las impresiones
	// no se confundan los pagos del último cobro parcial con pagos del cierre de ticket. Viene del TPV PC
	await new Promise(resolve => setTimeout(resolve, 1000));

	return Command.execute('doDirectPayment', { methodId: 1, amount: null });
}

export default addPrecondition(Preconditions.ensure(Permission.Ticket_AddPayment), splitTicketPayments);